// extracted by mini-css-extract-plugin
export default {"paragraph":"ValidationStep_paragraph__8TFjy","marginBottom":"ValidationStep_marginBottom__HBVXc"};